import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getActiveListings, getLeads, getActivities } from '../features/ihfSlice'
import { type IListings, type ILeads, type IActivies, type BaseQueryFnType } from './types'
import { IHF_END_POINT } from './endpoints'

const BASE_URL = process.env.REACT_APP_API_URL as string

export const ihfApi = createApi({
  reducerPath: 'ihfApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set('Accept', 'application/json')
      return headers
    }
  }) as BaseQueryFnType,
  endpoints: (builder) => ({
    getListings: builder.mutation({
      query: () => {
        return {
          url: IHF_END_POINT.LISTINGS,
          method: 'GET',
          credentials: 'include'
        }
      },
      transformResponse: (res: IListings) => {
        return res
      },
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(getActiveListings(data))
        } catch (error) {
          // console.error(error)
        }
      }
    }),
    getLeads: builder.mutation({
      query: (params) => {
        const { count } = params
        return {
          url: IHF_END_POINT.LEADS,
          method: 'GET',
          params: { count },
          credentials: 'include'
        }
      },
      transformResponse: (res: ILeads) => {
        return res
      },
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(getLeads(data))
        } catch (error) {
          // console.error(error)
        }
      }
    }),
    getActivities: builder.mutation({
      query: () => {
        return {
          url: IHF_END_POINT.ACTIVITY,
          method: 'GET',
          credentials: 'include'
        }
      },
      transformResponse: (res: IActivies) => {
        return res
      },
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(getActivities(data))
        } catch (error) {
          // console.error(error)
        }
      }
    })
  })
})

export const {
  useGetListingsMutation,
  useGetLeadsMutation,
  useGetActivitiesMutation
} = ihfApi
